// Configuration
export const NODE_ENV = import.meta.env.NODE_ENV;
export const ENVIRONMENT = import.meta.env.ENVIRONMENT;
export const PUBLIC_URL = import.meta.env.PUBLIC_URL;
export const PROJECT_VERSION = import.meta.env.PROJECT_VERSION;
export const PROJECT_NAME = import.meta.env.PROJECT_NAME;
export const PROJECT_TITLE = import.meta.env.PROJECT_TITLE;
export const PROJECT_CODE = import.meta.env.PROJECT_CODE;
export const TRACING_FORCE = import.meta.env.TRACING_FORCE;
export const TRACING_DEBUG = import.meta.env.TRACING_DEBUG;
export const SENTRY_DSN = import.meta.env.SENTRY_DSN;
export const AUTH0_DOMAIN = import.meta.env.AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.AUTH0_CLIENT_ID;

// Apis
export const TEAM_MANAGER_API_BASEURL = import.meta.env.TEAM_MANAGER_API_BASEURL;
export const COMPETITIONS_APP_BASEURL = import.meta.env.COMPETITIONS_APP_BASEURL;

// Application
export const PUBLIC_PATHS = ["/health", "/privacy-notice"];
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "HH:mm";
export const CLOCK_FORMAT = "HH:mm:ss";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const TIMESTAMP_FORMAT = `${DATE_FORMAT} ${CLOCK_FORMAT}`;
